import React, { useState } from 'react';

// Components //
import TitleSection from "../../molecules/title-section";
import CardStepTalent from "../../molecules/card-step-talent/cardStepTalent";
import contentfulRenderOptions from '../../../utils/contentfulRenderOption';
import equisCirculo from "../../../../src/assets/images/icons/x.svg";

// Interfaces //
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";

// Utils //
import { splitButtonText } from '../../../utils/helpers';
import './StepsToFindTalent.scss';

const StepsToFindTalent = (props: ReferenciaContenido) => {
    const {tituloGeneral, etiquetasArticulo, referenciaPlantillaContenido: cardStepList} = props;
    const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
    const [modalInfo, setModalInfo] = useState<boolean>(false);
    return (
        <div className='o-steps-to-find-talent'>
            <div className="container">
                <div className="o-steps-to-find-talent__inner">
                    <TitleSection title={tituloGeneral}/>
                    {etiquetasArticulo && (
                        <div className="o-steps-to-find-talent__inner__box-title-facts">
                            <div>
                                <span>{splitButtonText(etiquetasArticulo[0],0,":")}</span>
                                <p>{splitButtonText(etiquetasArticulo[0],1,":")}</p>
                            </div>
                            <div>
                                <span>{splitButtonText(etiquetasArticulo[1],0,":")}</span>
                                <p>{splitButtonText(etiquetasArticulo[1],1,":")}</p>
                            </div>
                        </div>
                    )}
                    <ol className={`o-steps-to-find-talent__listCards ${cardStepList[0].tituloBoton? "o-steps-to-find-talent__listCards--colors":""}`}>
                        {cardStepList && cardStepList.map((item) => (
                                <CardStepTalent
                                    key={item.titulo}
                                    title={item.tituloBanner}
                                    description={item.descripcion}
                                    image={item.imagenPrincipal[0].file.url}
                                    button={item.tituloBoton}
                                    setModalInfo={setModalInfo}
                                    modalInfo={item.referenciaContenido}
                                    setIsOpenModal={setIsOpenModal}
                                />
                            )
                        )}
                    </ol>
                </div>
            </div>
            {isOpenModal && (
                <div className="m-number-steps__modal">
                    <div className="m-card-step-talent__modal-content">
                        <button className="m-card-step-talent__modal-close" onClick={() => setIsOpenModal(false)}>
                                <img className="m-carousel-mentors__modal-close-img" src={equisCirculo} alt="icono x"/>
                        </button>
                        <div className="m-card-step-talent__modal-title">
                            <h2>{modalInfo[0].tituloBanner}</h2>
                            {modalInfo[0]?.descripcion && contentfulRenderOptions(modalInfo[0]?.descripcion.json)}
                        </div>
                        <div className="m-card-step-talent__modal-text">
                            <h3>{modalInfo[0].tituloDescripcion}</h3>
                            <ul>
                                {modalInfo[0].descripcionFija.content[0].content.map((item)=>{
                                    return (
                                        <li>
                                            <img src={modalInfo[0].imagenPrincipal[1].file.url}></img>
                                            <span>{item.content[0].content[0].value}</span>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                        <div className="m-card-step-talent__modal-bottom">
                            <ul>
                                <li>
                                    <figure>
                                        <img src={modalInfo[0].imagenPrincipal[3].file.url}></img>
                                    </figure>
                                    <span>{modalInfo[0].id[0]}</span>
                                </li>
                                <li>
                                    <figure>
                                        <img src={modalInfo[0].imagenPrincipal[2].file.url}></img>
                                    </figure>
                                    <span>{modalInfo[0].id[1]}</span>
                                </li>
                            </ul>
                            <div>
                                <figure>
                                    <img src={modalInfo[0].imagenPrincipal[0].file.url}></img>
                                </figure>
                                <span>{modalInfo[0].tipoTitulo}</span>
                            </div>
                            <a href={modalInfo[0].redireccionBoton}>{modalInfo[0].tituloBoton}</a>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default StepsToFindTalent;